module.exports = __webpack_public_path__ + "img/analyse.e25a3c3a.png";